import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import Carousel from '../components/Carousel';

function Home() {
  const [settings, setSettings] = useState({});
  const [carouselSlides, setCarouselSlides] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/api/settings/public'),
      api.get('/api/carousel'),
      api.get('/api/categories')
    ])
      .then(([settingsRes, carouselRes, categoriesRes]) => {
        setSettings(settingsRes.data);
        setCarouselSlides(carouselRes.data || []);
        setCategories(categoriesRes.data || []);
      })
      .catch(err => console.error('Failed to fetch data:', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="loading">A carregar...</div>;
  }

  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1>{settings.site_name || 'Wedding Attire'}</h1>
          <p>{settings.site_tagline || 'Elegant Men\'s Wedding Fashion'}</p>
          <hr className="hero-divider" />
          {settings.main_page_intro && (
            <div
              style={{
                maxWidth: '680px',
                margin: '0 auto 40px',
                lineHeight: '1.8',
                color: 'var(--text-secondary)',
                fontSize: '1.02rem',
                fontWeight: 300
              }}
            >
              {settings.main_page_intro.split('\n').map((paragraph, i) => (
                <p key={i} style={{ marginBottom: '1rem' }}>{paragraph}</p>
              ))}
            </div>
          )}
        </div>
        <Carousel slides={carouselSlides} />
      </section>

      {categories.length > 0 && (
        <section className="categories-section">
          <div className="container">
            <h2>As nossas coleções</h2>
            <div className="category-list">
              {categories.map(cat => (
                <Link
                  key={cat.id}
                  to={`/catalog/${cat.slug}`}
                  className="category-btn"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Home;
